import { computed } from 'vue';
import { createContext } from '../../utils/create-context.js';

const [EnvironmentContextProvider, useEnvironmentContext] = createContext("EnvironmentContext");
const DEFAULT_ENVIRONMENT = computed(() => ({
  getRootNode: () => document,
  getDocument: () => document,
  getWindow: () => window
}));

export { DEFAULT_ENVIRONMENT, EnvironmentContextProvider, useEnvironmentContext };
